import axios from 'axios';
import { parse } from 'date-fns';
import { API_URL } from '../config';
import { DATE_FORMAT_SHORT, EKENG_DATE_FORMAT, GENDER } from '../constants';

function transformUser(data) {
  const {
    firstName,
    lastName,
    firstNameEn,
    lastNameEn,
    socCard,
    gender,
    passport,
    passportFrom,
    resident,
    citizenship,
    country,
    state,
    cityVillage,
    street,
    cellPhone,
    phone,
  } = data.userDetails;
  let { birthday, passportGiven, passportValidUntil } = data.userDetails;
  birthday = parse(birthday, DATE_FORMAT_SHORT, new Date());
  passportGiven = parse(passportGiven, DATE_FORMAT_SHORT, new Date());
  passportValidUntil = parse(passportValidUntil, DATE_FORMAT_SHORT, new Date());
  return {
    ...data,
    firstName,
    lastName,
    firstNameEn,
    lastNameEn,
    socCard,
    gender,
    passport,
    passportFrom,
    resident,
    citizenship,
    country,
    state,
    cityVillage,
    street,
    cellPhone,
    phone,
    birthday,
    passportGiven,
    passportValidUntil,
  };
}

export const getUser = () => {
  const URL = `${API_URL}/user/me`;
  return axios.get(URL).then((response) => transformUser(response.data.user));
};

export const updateUser = (data, userId) => {
  const URL = `${API_URL}/user`;
  return axios
    .put(`${URL}/${userId}`, data)
    .then((response) => transformUser(response.data.user));
};

const newAxiosInstance = axios.create(); // to bypass humps

function transformEkengData(data) {
  const user = {};
  user.firstName = data.FirstName;
  user.lastName = data.LastName;
  user.firstNameEn = data.FirstNameEn;
  user.lastNameEn = data.LastNameEn;
  user.socCard = data.SSN;
  user.gender = data.Gender.toLowerCase() === 'm' ? GENDER.MALE : GENDER.FEMALE;
  const bday = data.BirthDate;
  user.birthday = parse(bday, EKENG_DATE_FORMAT, new Date());
  user.passport = data.DocumentNumber;
  user.passportFrom = data.DocumentDepartment;
  const givenDate = data.IssuanceDate;
  user.passportGiven = parse(givenDate, EKENG_DATE_FORMAT, new Date());
  const validDate = data.ValidityDate;
  user.passportValidUntil = parse(validDate, EKENG_DATE_FORMAT, new Date());
  user.resident = 1;
  user.citizenship = data.country;
  user.country = data.country;
  [user.state] = data.state;
  [user.cityVillage] = data.city_village;
  user.street = `${data.Street} ${data.Building} ${data.BuildingType} ${data.Apartment}`;
  return user;
}

export const getUserFromEkeng = (data) => {
  const URL = `${API_URL}/citizen?documentType=passport&documentNumber=${data.passport}&dob=${data.dob}`;
  return newAxiosInstance
    .get(URL)
    .then((response) => transformEkengData(response.data));
};

export const updateUserPass = (passwords, userId) => {
  const URL = `${API_URL}/user/${userId}/change-password`;
  return axios.put(`${URL}`, passwords);
};
